// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"048ef850","455":"daa9160e","977":"021ce972"}[chunkId] + ".chunk.js";
};